import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import Credential from "pages/_components/fields/credentials/Credential";
import { Field, Form, Formik } from "formik";
import Checkbox from "pages/_components/Checkbox";
import * as Yup from "yup";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import { bool } from "prop-types";
import { push } from "connected-react-router";
import { actions as discountsActions } from "reducers/discounts";
import Button from "pages/_components/Button";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import gaEventTracker, { events } from "util/gaEventTracker";
import TitleColumns from "../DiscountCreation/components/TitleColumns";
import EcheqList from "../DiscountCreation/components/List";

const DiscountReviewPartialsPage = ({ isDesktop }) => {
    const {
        fetching,
        transactionsEcheqDiscount,
        negotiatePartial,
        transaction,

        discountRequiredCredentials,
        discountTicket,
    } = useSelector((_state) => _state.discounts);
    const { id } = useParams();
    const dataLot = transactionsEcheqDiscount?.find((item) => item.idTransaction === id);

    const {
        echeqs: partialEcheqs,
        totalAmount: partialTotalAmount,
        totalEffectiveAmount: partialTotalEffectiveAmount,
    } = negotiatePartial;

    const { status: discountTicketStatus, idTransaction: discountTicketId } = discountTicket;
    const dispatch = useDispatch();
    const row = isDesktop ? 1 : 6;

    const [formRef, setFormRef] = useState();
    const [isValidating, setIsValidating] = useState(false);
    const credentialType = discountRequiredCredentials?.includes("otp") ? "otp" : "password";

    useEffect(() => {
        dispatch(discountsActions.getPartialEcheqs(id));
        dispatch(discountsActions.fetchCredentialGroup());
    }, [dispatch, id]);

    useEffect(() => {
        const validTransactionStatus = ["PENDING", "PROCESSING", "FINISHED"];

        if (isValidating && discountTicketStatus === "INVALID_CREDENTIAL") {
            setIsValidating(false);
            formRef.setErrors({
                credential: i18n.get(
                    credentialType === "password"
                        ? "preferences.password.password.incorrect"
                        : "login.step1.secondFactor.invalid",
                ),
            });
        } else if (isValidating && discountTicketStatus === "LIMIT_ERROR") {
            setIsValidating(false);
        } else if (isValidating && validTransactionStatus.includes(discountTicketStatus) && discountTicketId?.length) {
            dispatch(push(`/transaction/${discountTicketId}`));
        }
    }, [isValidating, setIsValidating, formRef, discountTicketStatus, discountTicketId]);

    const submit = (values) => {
        setIsValidating(true);

        let sumaPlazos = 0;
        for (let i = 0; i < partialEcheqs.length; i++) {
            const difference =
                new Date(partialEcheqs[i]?.fecha_pago)?.getTime() -
                new Date(partialEcheqs[i]?.fecha_emision)?.getTime();
            const plazo = Math.ceil(difference / (1000 * 3600 * 24));
            sumaPlazos += plazo;
        }

        gaEventTracker.triggerEvent(
            events.echeq_negociar_aprobados({
                datetime: new Date(),
                echeqs: partialEcheqs,
                plazoPromedio: partialEcheqs?.length ? sumaPlazos / partialEcheqs?.length : null,
                Id_lote: id,
            }),
        );

        // ARBIBIMPLE-9634: Este flujo no se daria porque todos los lotes parciales pasan por el flujo de apertura normal
        dispatch(
            discountsActions.createDiscount({
                account: transaction?.account,
                [`_${credentialType}`]: values.credential,
                amount: {
                    quantity: partialTotalEffectiveAmount.quantity || 0,
                    currency: partialTotalEffectiveAmount.currency || "ARS",
                },
                option: "negotiate.echeqs",
                idTransactionBatch: id,
            }),
        );
    };

    return (
        <>
            <Notification scopeToShow="DiscountReviewPartialsPage" />
            <ResponsiveHeader defaultTitle={i18n.get("", "Descuento de Echeqs")} />
            <MainContainer showLoader={fetching}>
                <CustomText text="Controlá los datos" className="discounts-echeq-review__date-control" />
                <GridTable className="details deposit-partials-details-list ">
                    <GridTable.Container columns={3} rows={2}>
                        <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                            <CustomData
                                titleText="detail.discounts.solicitor"
                                titleTextType="I18N"
                                valueText={dataLot?.solicitor}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1} columnWidth={1}>
                            <CustomData
                                titleText="detail.discounts.totalAmount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount
                                        currency={partialTotalAmount?.currency}
                                        quantity={partialTotalAmount?.quantity}
                                    />
                                }
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={1} columnWidth={1}>
                            <CustomData
                                dataClass="discount-amount-tag tag tag-warning"
                                titleText="detail.discounts.totalEffectiveAmount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount
                                        currency={partialTotalEffectiveAmount?.currency}
                                        quantity={partialTotalEffectiveAmount?.quantity}
                                    />
                                }
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={2} columnWidth={1}>
                            <CustomData
                                titleText="detail.discounts.creditAccount"
                                titleTextType="I18N"
                                valueText={dataLot?.account}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={2} columnWidth={1}>
                            <CustomData
                                titleText="detail.discounts.documentQuantity"
                                titleTextType="I18N"
                                valueText={partialEcheqs?.length ?? 0}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={2} columnWidth={1}>
                            <CustomData
                                titleText="detail.discounts.processDate"
                                titleTextType="I18N"
                                valueText={
                                    !dataLot?.dateEmitted ? (
                                        "-"
                                    ) : (
                                        <FormattedDate date={dataLot?.dateEmitted} dateFormat="DD/MM/YYYY HH:MM:SS" />
                                    )
                                }
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                <EcheqList
                    fetchingWithPreviousData
                    items={partialEcheqs || []}
                    noDataText="global.no.results"
                    noFiltersDataText="debin.global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            key={`echeq-item-${item?.echeqNumber}`}
                            columnsTemplate="repeat(6, 1fr)"
                            className={!isDesktop && "box box-shadow"}>
                            <GridTable.Data columnStart={1} rowStart={1}>
                                <CustomText text={item?.cheque_numero} />
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={1}>
                                <CustomText text={item?.cheque_caracter} />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={3}
                                rowStart={1}
                                className="echeq-table__emisor"
                                alignX="center">
                                <CustomText text={item?.emisor_razon_social} />
                            </GridTable.Data>
                            <GridTable.Data columnStart={4} rowStart={1} flexDirection="column" alignX="center">
                                <CustomText text="CUIT" />
                                <CustomText text={item?.emisor_cuit} />
                            </GridTable.Data>
                            <GridTable.Data columnStart={5} rowStart={1}>
                                <CustomData
                                    titleText="transfer.amountField.label"
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedAmount currency={item?.emisor_moneda} quantity={item?.monto} />
                                    }
                                    valueTextType="STRING"
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={6} rowStart={1}>
                                <CustomData
                                    titleText="payThirdParties.process.label"
                                    titleTextType="I18N"
                                    valueText={<FormattedDate date={item?.fecha_pago} />}
                                    valueTextType="STRING"
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable className="tablelist emited">
                            <GridTable.Header>
                                <GridTable.Container rows={row} columnsTemplate="repeat(6, 1fr)">
                                    <TitleColumns canCheck={false} />
                                </GridTable.Container>
                            </GridTable.Header>
                            <GridTable.Body>{listItem}</GridTable.Body>
                        </GridTable>
                    )}
                </EcheqList>
                <Formik
                    ref={(el) => setFormRef(el)}
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                    validationSchema={Yup.object().shape({
                        credential: Yup.string().required(i18n.get("deposits.request.required")),
                        termAndConditions: Yup.bool()
                            .test(
                                "is-true",
                                i18n.get("forms.inputFile.massivePayments.invalid.required"),
                                (value) => !!value,
                            )
                            .required(i18n.get("forms.inputFile.massivePayments.invalid.required")),
                    })}
                    onSubmit={submit}>
                    {({ setFieldValue, values }) => (
                        <Form>
                            {/* <Row className="form-actions discounts-echeq-review__form-actions">
                                </Row> */}
                            <Row className="form-actions">
                                <Col xs={12} md={10} mdOffset={2}>
                                    <div className="discounts-echeq-review__form-actions">
                                        <Field
                                            component={Checkbox}
                                            idForm="discounts.new.lastForm"
                                            name="termAndConditions"
                                            labelText="discounts.new.review.termAndConditions.label"
                                            labelTextProps={{ defaultValue: "Aceptá los\u00A0" }}
                                        />
                                        <Button
                                            block
                                            className="btn btn-link discounts-echeq-review__form-actions-terms"
                                            onClick={() => {
                                                setFieldValue("termAndConditions", !values?.termAndConditions, false);
                                                dispatch(push("/termsAndConditions"));
                                            }}
                                            defaultLabelText="Términos y Condiciones"
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} md={4} mdOffset={2}>
                                    <Field
                                        idForm="form.credential"
                                        name="credential"
                                        labelText="form.credential.token.label"
                                        placeholderText="Ej: 120573"
                                        component={Credential}
                                        type={credentialType}
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6} className="align-items-end">
                                    <div className="form-group">
                                        <div className="form-group">
                                            <span className="data-label">
                                                <span> &nbsp;</span>
                                            </span>
                                            <div className="button-group">
                                                <Button
                                                    block
                                                    type="submit"
                                                    label="global.send"
                                                    bsStyle="primary"
                                                    loading={isValidating}
                                                    disabled={
                                                        !values.termAndConditions || !values.credential.length > 0
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

DiscountReviewPartialsPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default DiscountReviewPartialsPage;
